module.exports = __webpack_public_path__ + "img/3.e7191f22.png";